import { useEffect, useRef, useState } from "react";

// Wraps a value and flashes with the same pale-indigo animation used by the
// material table whenever `flashKey` changes. Keep this simple: it never
// flashes on the first render.
export function FlashValue({
  children,
  flashKey,
  className,
  style,
}: {
  children: React.ReactNode;
  flashKey: string | number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const [nonce, setNonce] = useState(0);
  const first = useRef(true);
  const prev = useRef(flashKey);
  useEffect(() => {
    if (first.current) { first.current = false; prev.current = flashKey; return; }
    if (prev.current !== flashKey) {
      prev.current = flashKey;
      setNonce((n) => n + 1);
    }
  }, [flashKey]);
  return (
    <span
      key={nonce}
      className={[nonce > 0 ? "cell-flash" : "", className].filter(Boolean).join(" ")}
      style={{ display: "inline-block", ...style }}
    >
      {children}
    </span>
  );
}
